import { getAllProductsAndVariants } from "./manageProducts";

export const allProductMixin = {
    data() {
        return {
            allProducts: [],
            allAuctions: [],
        };
    },
    computed: {
       
    },
    created() {
        this.initAllProductMixin();
    },
    methods: {
        async initAllProductMixin() {
            await this.getProducts();
        },
        async getProducts() {
            let res = await getAllProductsAndVariants();

            this.allProducts = res.varianti;

            this.allAuctions = this.allProducts.filter(
                product =>
                    Array.isArray(product._astaCorrente) &&
                    product._astaCorrente.length > 0
                );
        },
        getAuctionProduct(pId, vId) {
            return this.allAuctions.find(
                (auction) => 
                    auction._id == vId &&
                    auction?._prodotto?.[0]?._id == pId
            );
        },
        getProduct(pId, vId) {
            return this.allProducts.find(
                (item) => 
                    item._id == vId &&
                    item?._prodotto?.[0]?._id == pId
            );
        },
        isAuctionProduct(pId, vId ){
            return this.allAuctions.some(
                (auction) => 
                    auction._id == vId &&
                    auction?._prodotto?.[0]?._id == pId
                );
        }
    }
}
